function CategoriesTags({ category }) {
	return (
		<div className="category-tags">
			{category.tags && category.tags.map((tag, i) => <div key={i}>{tag.name}</div>)}
		</div>
	);
}

export default CategoriesTags;
